module.exports = __webpack_public_path__ + "img/OnePunch1.e3458b76.jpg";